import request from "@/utils/request";

export function getQuestion() {
    const data = {}
    if (sessionStorage.getItem('share')) {
        data['share'] = sessionStorage.getItem('share')
    }
    return request({
        url: "/exam-by-student",
        method: "post",
        data
    });
}

export function submitAnswer(data) {
    if (sessionStorage.getItem('share')) {
        data['share'] = sessionStorage.getItem('share')
    }
    return request({
        url: "/submit-answer",
        method: "post",
        data,
    });
}

export function getScore(data) {
    if (sessionStorage.getItem('share')) {
        data['share'] = sessionStorage.getItem('share')
    }
    return request({
        url: "/calculate-score",
        method: "post",
        data,
    });
}

export function getTotalQuestion() {
    const data = {}
    if (sessionStorage.getItem('share')) {
        data['share'] = sessionStorage.getItem('share')
    }
    return request({
        url: "/total-question",
        method: "post",
        data
    });
}

export function getForms(params) {
    return request({
        url: "/forms",
        method: "get",
        params,
    });
}
export function getForm(id) {
    return request({
        url: "/forms/" + id,
        method: "get",
    });
}
